import { supabase } from '../config/supabaseConfig.ts';

export const proyectsClientService = {

  addProyectClient: async (projects, clientId) => {
    try {
      // 1. Preparamos el array de objetos para la inserción masiva.
      //    Cada objeto debe tener las columnas de la tabla: id_proyecto y id_cliente.
      const projectsToInsert = projects.map(project => ({
        id_proyecto: project,
        id_cliente: clientId
      }));

      // 2. Realizamos la inserción masiva pasando el array a .insert()
      const { data, error } = await supabase
        .from('clientes_projectos')
        .insert(projectsToInsert)
        .select(); // Opcional: .select() para devolver los datos insertados

      if (error) throw error;

      // Devolvemos los datos insertados y un indicador de éxito.
      return { data, error: null };
    } catch (error) {
      console.error('Error al agregar cliente al proyecto:', error);
      return { data: null, error };
    }
  },

  removeProyectClient: async (id) => {
    try {
      const { data, error } = await supabase
        .from('clientes_projectos')
        .delete()
        .eq('id_cliente', id)
      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      throw error;
    }
  },

  updateProyectClient: async (proyect_id, client_id) => {
    try {
      const { data, error } = await supabase
        .from('clientes_projectos')
        .update({ proyect_id })
        .eq('client_id', client_id);
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al actualizar cliente del proyecto:', error);
      throw error;
    }
  }
}